/* eslint-disable import/no-mutable-exports */
let REACT_APP_APP_URL = '';

function setReactAppAppUrl(s) {
  REACT_APP_APP_URL = s;
}

export { REACT_APP_APP_URL, setReactAppAppUrl };
